import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, DatePicker, Switch, Button, Modal, notification, Spin, Upload } from 'antd';
import moment from 'moment';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import WasteTypeSelect from '../../../../../../components/WasteTypeSelect';
import MeasurementUnitSelect from '../../../../../../components/MeasurementUnitSelect';

const langContext = 'reserved-area.construction';

export default ({ construction_uid, uid, onClose, onLoad }) => {
  const [data, setData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  useEffect(() => {
    if (uid) {
      setLoading(true);
      _service({
        method: 'GET',
        url: '/construction/waste/consume',
        data: { uid },
        success: (response) => {
          const responseData = response.json;
          responseData.estimated_date = moment(responseData.estimated_date, 'YYYY-MM-DD');
          setData(response.json);
          setLoading(false);
        },
        fail: (e) => {
          notification["error"]({
            message: 'Erro no carregamento dos dados dos Residuos a consumir',
            description: e.response.json.error,
          });
        }
      });
    }
  }, []);

  const intl = useIntl();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const onSubmit = () => {
    setSubmitting(true);
    form.submit();
  };

  const onCancel = () => {
    setIsModalVisible(false);
    if (onClose) {
      onClose();
    }
  };

  const onChange = (value) => {
    console.log('changed', value);
  };

  function onFinish(values) {
    setSubmitting(true);
    const { waste_type, amount, measurement_unit, radius, own_transport } = values;
    const estimated_date = values.estimated_date.format('YYYY-MM-DD');
    if (uid) {
      _service({
        method: 'POST',
        url: '/construction/waste/consume',
        data: {
          uid,
          construction_uid,
          waste_type_uid: waste_type.uid,
          amount,
          measurement_unit_uid: measurement_unit.uid,
          radius,
          estimated_date,
          own_transport
        },
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Resíduo a Consumir editado com sucesso',
            });
            setLoading(false);
            setSubmitting(false);
            setIsModalVisible(false);
            if (onLoad) {
              onLoad();
            }
            if (onClose) {
              onClose();
            }
          } else {
            notification["warning"]({
              message: 'Não foi possível editar o Resíduo a Consumir',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Não foi possível editar o Resíduo a Consumir, contacte-nos através do chat de suporte.'
          });
        }
      });
    } else {
      _service({
        method: 'PUT',
        url: '/construction/waste/consume',
        data: {
          construction_uid,
          waste_type_uid: waste_type.uid,
          amount,
          measurement_unit_uid: measurement_unit.uid,
          radius,
          estimated_date,
          own_transport
        },
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Resíduo a Consumir criado com sucesso.',
            });
            setLoading(false);
            setSubmitting(false);
            setIsModalVisible(false);
            if (onLoad) {
              onLoad();
            }
            if (onClose) {
              onClose();
            }
          } else {
            notification["warning"]({
              message: 'Resíduo a Consumir não foi criado com sucesso',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Não foi possível criar o Resíduo a Consumir, contacte-nos através do chat de suporte.',
          });
        }
      });
    }
  };

  function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
    setSubmitting(false);
  }

  return (
    <>
      <Modal
        title={intl.formatMessage({ id: langContext + '.waste.to-consume.title' })}
        visible={true}
        onOk={onSubmit}
        onCancel={onCancel}
        footer={[
          <Button onClick={onCancel}>
            <FormattedMessage id={`${langContext}.button.cancel`} />
          </Button>,
          <Button type="primary" htmlType="submit" loading={submitting} onClick={onSubmit}>
            <FormattedMessage id={`${langContext}.button.save`} />
          </Button>]}
      >
        {loading ? <Spin /> :
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={data}
          >
            <Form.Item
              name={['waste_type', 'uid']}
              label={intl.formatMessage({ id: langContext + '.fields.waste-type' })}
              rules={[
                { required: true }
              ]}
            >
              <WasteTypeSelect />
            </Form.Item>
            <Form.Item label={intl.formatMessage({ id: langContext + '.fields.amount' })}>
              <Input.Group compact>
                <Form.Item
                  name={'amount'}
                  label={intl.formatMessage({ id: langContext + '.fields.amount' })}
                  noStyle
                  rules={[
                    { required: true }
                  ]}
                >
                  <InputNumber placeholder={intl.formatMessage({ id: langContext + '.fields.value' })}
                    defaultValue={1000}
                    formatter={(value) => `${value}`.replace(/(\d)(\d{2})$/, "$1,$2")}
                    onChange={onChange}
                  />
                </Form.Item>
                <Form.Item
                  name={['measurement_unit', 'uid']}
                  label={intl.formatMessage({ id: 'components.measurement-unit-select.title' })}
                  noStyle
                  rules={[
                    { required: true }
                  ]}
                >
                  <MeasurementUnitSelect />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item label={intl.formatMessage({ id: langContext + '.fields.radius' })}>
              <Form.Item
                name={'radius'}
                label={intl.formatMessage({ id: langContext + '.fields.radius' })}
                noStyle
                rules={[
                  { required: true }
                ]}
              >
                <InputNumber min={1} />
              </Form.Item>
            </Form.Item>
            <Form.Item
              name={'estimated_date'}
              label={intl.formatMessage({ id: langContext + '.fields.estimated-date' })}
              rules={[
                { required: true },
                { type: 'date' }
              ]}
            >
              <DatePicker />
            </Form.Item>
            <Form.Item
              name={'own_transport'}
              label={intl.formatMessage({ id: langContext + '.fields.own-transport' })}
            >
              {
                data.own_transport ? (<Switch defaultChecked />) : (<Switch />)
              }
            </Form.Item>
          </Form>
        }
      </Modal>
    </>
  );
}

